import ReactDOM from "react-dom"
import React from "react"
import { Router, Switch, Route } from "react-router-dom"
import history from "./history"
import RegistrationComponent from "./components/RegistrationComponent"
import './i18n'
import 'shared/helpers/watch-iframe-height'
ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <Switch>
        <Route
          exact
          path="/"
          component={RegistrationComponent}
        />
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById("app")
)
